import { takeEvery, fork, put, call } from 'redux-saga/effects'
import { get, post, postAllowUserFirmwareUpgrade } from "@modul-connect/shared/utils/ajax"

function* setAssetTrackerWaitingTime({ mainboxId, waitingTimeSeconds }) {
  const command = {
    id:  'vehicle/' + mainboxId,
    waitingTimeSeconds
  }

  const result = yield call(post, '/cmd/box/set-asset-waiting-time', { body: JSON.stringify(command) })
  if (result && result.status) {
    switch (result.status) {
      case 'ok':
        yield put({ type: 'ASSET_TRACKER_WAITING_TIME_SET', data: command})
        return
      default:
        yield put({ type: 'ASSET_TRACKER_WAITING_TIME_FAILED', data: command})
    }
  }
}

export function* vehicleSagas() {
  yield takeEvery('ALLOW_USER_FIRMWARE_UPGRADE', postAllowUserFirmwareUpgrade)
  yield takeEvery('SET_ASSET_TRACKER_WAITING_TIME', setAssetTrackerWaitingTime)
}